'use client';

import { Location } from '@hc-frontend/core-types';
import { createContext, useContext, useMemo } from 'react';

import type { GeoIPProviderProps } from './use-geo-ip.types';

const GeoIPContext = createContext<Location | null>(null);

export const useGeoIP = () => useContext(GeoIPContext);

export function GeoIPProvider({ children, location }: GeoIPProviderProps) {
  const value = useMemo(() => location, [location]);

  return (
    <GeoIPContext.Provider value={value}>{children}</GeoIPContext.Provider>
  );
}
